module.exports = __webpack_public_path__ + "static/media/8.76e0c34d.jpg";